export enum StepKeysEnum {
  PERSONAL_INFO = "PERSONAL_INFO",
  EDUCATION = "EDUCATION",
  EXPERIENCE = "EXPERIENCE",
  SKILLS = "SKILLS",
  CONFIGURATION = "CONFIGURATION",
}
